import React from 'react';
export function BonusSection() {
  const bonuses = [{
    num: '1',
    title: 'El Botiquín de Guerra Civil',
    icon: '🩺',
    desc: 'La lista completa de insumos médicos críticos de venta libre y cómo usarlos para tratar heridas, infecciones y emergencias cuando los hospitales estén colapsados.',
    value: '$97'
  }, {
    num: '2',
    title: 'El Chef del Apagón',
    icon: '🍳',
    desc: 'Recetario táctico de alta energía sin fuego ni electricidad. 5 recetas de "Alta Moral" que mantienen a tu familia nutrida y con ánimo cuando el gas no funciona.',
    value: '$47'
  }, {
    num: '3',
    title: 'La Despensa de los $50',
    icon: '💰',
    desc: 'La lista de compras exacta para alimentar a una familia de 4 personas durante 30 días completos con un solo viaje al supermercado y presupuesto mínimo.',
    value: '$67'
  }, {
    num: '4',
    title: 'El Grifo Muerto',
    icon: '💧',
    desc: 'Manual técnico para extraer, filtrar y potabilizar agua de 5 fuentes urbanas ocultas que existen en tu propio edificio. Agua potable infinita sin salir a la calle.',
    value: '$87'
  }, {
    num: '5',
    title: 'Mente de Hierro',
    icon: '🧠',
    desc: 'El protocolo psicológico de fuerzas especiales para mantener la calma, liderar a tu familia y tomar decisiones correctas cuando el pánico se apodera de todos.',
    value: '$127'
  }];
  return <section className="bg-gradient-to-b from-[#0a0a0a] to-[#0f0f0f] py-12 px-5" data-id="element-52">
      <div className="max-w-[800px] mx-auto" data-id="element-53">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold text-center mb-3 leading-[1.2]" data-id="element-54">
          Y además recibís <span className="text-brand-orange" data-id="element-55">GRATIS</span>{' '}
          estos 5 bonos exclusivos
        </h2>
        <p className="text-center text-[#aaa] mb-8 text-sm" data-id="element-56">
          Con tu compra hoy, accedés instantáneamente a todo esto sin costo
          adicional:
        </p>

        <div className="space-y-3" data-id="element-57">
          {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-to-br from-[#111] to-[#1a1a1a] border border-brand-orange rounded-xl p-5 md:p-6 flex flex-col sm:flex-row gap-4 items-start relative overflow-hidden" data-id="element-58">
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-brand-orange to-[#ff8c00]" data-id="element-59"></div>
              <div className="bg-gradient-to-br from-brand-orange to-brand-darkOrange text-white font-oswald text-xl font-bold w-12 h-12 rounded-full flex items-center justify-center shrink-0" data-id="element-60">
                {bonus.num}
              </div>
              <div data-id="element-61">
                <h3 className="font-oswald text-lg md:text-xl text-brand-orange mb-1 font-semibold flex items-center gap-2" data-id="element-62">
                  <span data-id="element-63">{bonus.icon}</span> {bonus.title}
                </h3>
                <p className="text-sm text-[#bbb] leading-[1.5] mb-2" data-id="element-64">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2" data-id="element-65">
                  <span className="inline-block bg-brand-orange/15 border border-brand-orange text-brand-orange py-0.5 px-3 rounded-full text-xs font-semibold" data-id="element-66">
                    Valor: {bonus.value}
                  </span>
                  <span className="inline-block bg-gradient-to-br from-brand-orange to-brand-darkOrange text-white py-0.5 px-3 rounded-full text-xs font-bold" data-id="element-67">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}